import { render, staticRenderFns } from "./ListDeletedForms.vue?vue&type=template&id=6b8f2762&"
import script from "./ListDeletedForms.vue?vue&type=script&lang=ts&"
export * from "./ListDeletedForms.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeletedForms.vue?vue&type=style&index=0&id=6b8f2762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports